module.exports = __webpack_public_path__ + "img/PD1500795935603716096.11268acd.png";